// src/App.js
import React from "react";
import { Layout, Typography, Breadcrumb } from "antd";
import ContractsDisplay from "./ContractsDisplay"; // Import the new component
import "./App.css";

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

function App() {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            padding: "0 16px",
            background: "#fff",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Title level={3} style={{ color: "#001529", margin: "16px 0" }}>
            OpenClear.ca - Canadian Government Spending Visualized
          </Title>
        </Header>

        <Content style={{ margin: "0 16px" }}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>Contracts</Breadcrumb.Item>
          </Breadcrumb>

          {/* Render the ContractsDisplay component */}
          <ContractsDisplay />
        </Content>

        <Footer
          style={{
            textAlign: "center",
            background: "#f0f2f5",
            padding: "15px 50px",
          }}
        >
          OpenClear.ca ©{new Date().getFullYear()} | Data sourced from Open
          Canada | Not affiliated with the Government of Canada
        </Footer>
      </Layout>
    </Layout>
  );
}

export default App;
